export default "__VITE_ASSET__DDlLVjBe__"